/* 用户相关信息接口 */

import axios from 'axios';
import qs from 'qs';

export default {
  bankCardContract () {
    return axios.post('/cmsform/site/cmssitemenucontent/getBankCardContract.ht');
  },
  registerContract () {
    return axios.get('/cmsform/site/cmssitemenucontent/getRegisterContract.ht');
  },
  userRegister (params) { // 用户注册
    return axios.get('/crmform/customer/crmCustomer/register.ht', {
      params: {
        customerLoginName: params.customerLoginName,
        customerLoginPwd: params.customerLoginPwd,
        validCode: params.validCode,
        customerType: params.customerType,
        inviteCode: params.inviteCode
      }
    });
  },

  userLogin (params) { // 用户登录
    return axios.get('/crmform/customer/crmCustomer/login.ht', {
      params: {
        loginName: params.loginName,
        password: params.password,
        smsCode: params.smsCode,
        isSmsLogin: params.isSmsLogin
      }
    });
  },

  userLogout () { // 用户注销
    return axios.get('/crmform/customer/crmCustomer/exit.ht');
  },

  validateImageVerificationCode (params) { // 验证图形验证码
    return axios.get('/crmform/customer/crmCustomer/checkValidCode.ht', {
      params: {
        validCode: params.validCode
      }
    });
  },

  validateOldLoginPassword (params) { // 验证旧密码是否正确
    return axios.get('/crmform/customer/crmCustomer/checkPassword.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        password: params.password
      }
    });
  },

  getSMSVerificationCode (params) { // 获取短信验证码
    return axios.post('/crmform/customer/crmCustomer/getValidcode.ht', qs.stringify({
      mobile: params.mobile,
      isForRegister: params.isForRegister === true ? '1' : '0'
    }));
  },

  forgetPassword (params) { // 忘记密码
    return axios.get('/crmform/customer/crmCustomer/forgetPwd.ht', {
      params: {
        mobile: params.mobile,
        validCode: params.validCode,
        password: params.password,
        confirmPassword: params.confirmPassword
      }
    });
  },

  updatePassword (params) { // 修改密码
    return axios.get('/crmform/customer/crmCustomer/resetPassword.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        oldPwd: params.oldPwd,
        newPwd: params.newPwd
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/user/user.js